
    import './styles.scoped.css';
    export default {
  "token-list": "awsui_token-list_1bi5g_1chns_5",
  "token-list-item": "awsui_token-list-item_1bi5g_1chns_9",
  "token-overflow-trigger": "awsui_token-overflow-trigger_1bi5g_1chns_13",
  "overflow-dropdown": "awsui_overflow-dropdown_1bi5g_1chns_17"
};
  